import Rollbar from 'rollbar';
import LocalStorageConstants from '~/constants/LocalStorageConstants';
import {DATA_MODEL_VERSION} from '~/constants/App';
import {actionList} from '~/utils/middleware/actionRecorder';
import {ignoredMessages} from './ignore';
import Cookies from 'cookies-js';
import {__STAGING__, __TEST__, __DEVELOPMENT__} from '~/utils/env';

let initialState;
try {
  initialState = localStorage.getItem(LocalStorageConstants.SNAPSHOT) || '{}';
} catch (e) {
  initialState = '{}';
}

function transformer(payload) {
  payload.data = {
    actionHistory: actionList,
    dataModelVersion: DATA_MODEL_VERSION,
    initialState,
    internalUser: Cookies.get('internal')
  };
}

const rollbar = new Rollbar({
  accessToken: '63a92315a36348eb89888d24c51e1dea',
  captureUncaught: !(__TEST__ || __DEVELOPMENT__),
  captureUnhandledRejections: __STAGING__,
  enabled: !(__TEST__ || __DEVELOPMENT__),
  hostSafeList: ['customink.com'],
  ignoredMessages,
  transform: transformer,
  payload: {
    environment: import.meta.env.MODE,
    client: {
      javascript: {
        source_map_enabled: true,
        code_version: import.meta.env.NDX_REVISION,
        guess_uncaught_frames: true
      }
    }
  }
});

export default rollbar;
